import {CarteBancaireModel} from "../Models/CarteBancaireModel";
import {setUser} from "../store/actions";
import {UserModel} from "../Models/UserModel";
import {useDispatch} from "react-redux";
import axios from "axios";

export const useDeleteCard = (
    onBefore: () => void,
    onFinally: () => void,
    onSuccess: () => void,
    onError: () => void,
    user?: UserModel | null
): (cb: CarteBancaireModel, index: number) => void => {
    const dispatch = useDispatch()
    const deleteCard = (carte: CarteBancaireModel, index: number) => {
        if (user?.cartesBancaires) {
            onBefore()
            axios.delete(`${process.env.REACT_APP_BART_URL}/cartes-bancaires/${carte.stripeId}/delete`)
                .then(() => {
                    const newsCartesBancaires = user.cartesBancaires ? [...user.cartesBancaires] : []
                    newsCartesBancaires.splice(index, 1)
                    dispatch(setUser({...user, cartesBancaires: newsCartesBancaires}))
                    onSuccess()
                })
                .catch(onError)
                .finally(onFinally)
        }
    }

    return deleteCard
}
